"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EExternalAPI = void 0;
var EExternalAPI;
(function (EExternalAPI) {
    EExternalAPI["DAT"] = "dat";
    EExternalAPI["SCHWACKE"] = "schwacke";
    EExternalAPI["MOBILE_SELLER"] = "mobile-seller";
    EExternalAPI["MOBILE_SEARCH"] = "mobile-search";
    EExternalAPI["LINK_ENTRY"] = "link-entry";
    EExternalAPI["CUSTOMER"] = "customer";
    EExternalAPI["LOCO_SOFT_SOAP"] = "loco-soft-soap";
    EExternalAPI["LOCO_SOFT_DATABASE"] = "loco-soft-db";
    EExternalAPI["STELLANTIS_WEBSITE"] = "stellantis-website";
    EExternalAPI["US_VIN_DECODING"] = "us-vin";
    EExternalAPI["JUHU_AUTO"] = "juhu-auto";
})(EExternalAPI = exports.EExternalAPI || (exports.EExternalAPI = {}));
